import { gql } from "graphql-request";
export const CATEGORY_OFFERS_QUERY = gql`
    query categoryOffersQuery($categoryId: Int, $domainId: Int) {
        allDomainOffers(domainId: $domainId, categoryId: $categoryId) {
            offers(orderByDesc: weight, isDeleted: false, isActive: true) {
                slug
                translations {
                    key
                    value
                    language
                }
                logo {
                    fullPath
                }
            }
        }
    }
`;
